document.addEventListener("DOMContentLoaded", () => {
  const isFinePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  if (!isFinePointer) return;

  document.querySelectorAll("product-card").forEach((card) => {
    const video = card.querySelector("video.pn-card-hover-video");
    if (!video) return;

    const mediaEls = card.querySelectorAll(".product-card__image");

    const activate = () => {
      mediaEls.forEach(el => el.classList.add("pn-card-media-hidden"));
      video.classList.add("is-active");
      const p = video.play();
      if (p?.catch) p.catch(() => {});
    };

    const deactivate = () => {
      video.pause();
      try { video.currentTime = 0; } catch (e) {}
      video.classList.remove("is-active");
      mediaEls.forEach(el => el.classList.remove("pn-card-media-hidden"));
    };

    card.addEventListener("mouseenter", activate);
    card.addEventListener("mouseleave", deactivate);
  });
});